/**
 * QorTrace · Qelli pulse-funnel client (Iter199).
 *
 * Records {fired, click, signup} events against the cross-site
 * `qt-qelli-pulse` event surface so we can A/B intentText copy on
 * conversion data instead of vibes. Backend collection:
 * `qelli_pulse_events` (see /app/backend/qelli_pulse_events.py).
 *
 * Signup attribution: when a pulse fires, we stash the source key
 * under sessionStorage `qt_qelli_last_pulse_source`. If the visitor
 * signs up later in the same tab/session, `userAuth.signup` reads
 * that key and posts a `kind: "signup"` event — closing the loop
 * end-to-end on a per-source basis.
 *
 * All POSTs are fire-and-forget; telemetry never blocks user flow.
 */
const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const SS_KEY = "qt_qelli_last_pulse_source";


export function trackPulseEvent(source, kind, page) {
  if (!source || !kind) return;
  if (typeof window === "undefined") return;
  const body = {
    source,
    kind,
    page: page || (window.location && window.location.pathname) || null,
  };
  try {
    // keepalive=true so the request survives page navigation, which
    // is exactly the case when we record a "signup" event right
    // before navigating into the dashboard.
    fetch(`${API}/api/qelli/pulse-event`, {
      method:      "POST",
      headers:     { "Content-Type": "application/json" },
      credentials: "omit",
      keepalive:   true,
      body:        JSON.stringify(body),
    }).catch(() => { /* swallow */ });
  } catch {
    /* swallow */
  }
}


// Remember the most-recent pulse source so a downstream signup can
// attribute back to it. Called from `useQelliWarmPulse` after a
// pulse fires AND from QelliAvatar3D when the click is recorded.
export function rememberPulseSource(source) {
  if (!source || typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(SS_KEY, source);
  } catch { /* private mode / disabled storage */ }
}


export function consumePulseSource() {
  if (typeof window === "undefined") return null;
  try {
    const s = window.sessionStorage.getItem(SS_KEY);
    if (s) window.sessionStorage.removeItem(SS_KEY);
    return s || null;
  } catch {
    return null;
  }
}
